import { useEffect, useRef, useState } from 'react';
import { Platform } from 'react-native';

const isWeb = Platform.OS === 'web';
const DEFAULT_ROOT_MARGIN = '400px 0px';

/** Defer work until near the viewport on web; native treats content as in view immediately. */
export default function useLazyInView({ rootMargin = DEFAULT_ROOT_MARGIN, enabled = true } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(!isWeb || !enabled);

  useEffect(() => {
    if (!isWeb || !enabled) return;

    const target = ref.current;
    if (!target || typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin, threshold: 0 },
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, [rootMargin, enabled]);

  return { ref, inView };
}
